import { RoutesTree } from '@organisms/routesTree';

import { storageRoutesTree } from './storageRoutesTree';

export const StorageRoutes = () => {
    return <RoutesTree routesTree={storageRoutesTree} />;
};

export default StorageRoutes;
